/** Helper di formattazione condivisi tra CostoPersonalePage e AggregatoTable. */

export function euro(v) {
  return `€ ${(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function ore(v) {
  return (v || 0).toLocaleString("it-IT", { maximumFractionDigits: 1 });
}

export function labelChiave(row, groupBy) {
  if (groupBy === "codiceFiscale") {
    return row.cognome || row.nome ? `${row.cognome} ${row.nome}` : row.chiave;
  }
  if (groupBy === "gruppoCosto") {
    return row.nome || row.chiave;
  }
  return row.chiave || "Non classificato";
}
